import React, { useState } from "react";
import { Button } from "@mui/material";
import EnhancedAxios from "../../../axios/EnhancedAxios";
import { useSelector } from "react-redux";
import { AxiosResponse, AxiosError } from "axios";
import { successAlert } from "../../../utils/alerts/alerts";
const PublishGift = ({ gift }: any) => {
    const userToken = useSelector((state: any) => state.user.userToken);
    const [submitting, setSubmitting] = useState(false);
    const [published, setPublished] = useState(gift.is_published);
    const confirm = () => {
        EnhancedAxios(null, userToken)
            .put(
                `/admin/gifts/${gift.id}`,
                JSON.stringify({ is_published: true })
            )
            .then((res: AxiosResponse) => {
                successAlert(`تم نشر الهدية `);
                setSubmitting(false);
                    setPublished(true);
                setSubmitting(false);
            })
            .catch((error: AxiosError) => {
                setPublished(false);
            });
    };
    return (
        <Button
            variant="contained"
            color="success"
            size="small"
            disabled={published}
            onClick={confirm}
        >
            نشر
        </Button>
    );
};
export default PublishGift;
